import React from 'react'
import { Divider } from 'antd'

export const Heading = props => {
    return (
        <Divider className={`heading ${props.type}`} orientation={props.orientation || "left"}>{props.children}</Divider>
    )
}
